<template lang="html">
  <v-menu offset-x left top :close-on-content-click="false">
    <v-btn icon ripple slot="activator">
      <v-icon color="grey lighten-1">info</v-icon>
    </v-btn>
    <v-data-table
      v-bind:headers="dataHeaders"
      v-bind:items="data"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name}}</td>
        <td>{{ props.item.value }}</td>
      </template>
    </v-data-table>
  </v-menu>
</template>

<script>
export default {
  props: ['data'],

  data: function () {
    return {
      dataHeaders: [
        { text: 'Метка', align: 'left', sortable: false, value: 'labelPD' },
        { text: 'Значение', align: 'left', sortable: false, value: 'valuePD' }
      ]
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/components/ItemDataPopup.vue